module.exports = __webpack_public_path__ + "static/media/man-sad.a69541b1.png";